export default __webpack_public_path__ + "static/CircularStd-BlackItalic-43713ceea902d62ab9fbb34546545837.ttf";